import ReduxGetGameInfo from "../../../redux/redux_get_game_info";

export const getCurrentPriceArr = (gameNbrMonths) => {
    // totalNbrGameMonths is the total number of game months being played
    // gameNbrMonths is the number of months that the player has played (from gameData)
    const totalNbrGameMonths = ReduxGetGameInfo("totalGameMonths");
    const monthNbr = +totalNbrGameMonths - gameNbrMonths;
    const retirementPriceArr = ReduxGetGameInfo("retirementPriceArr");  
    let currentPriceArr = 
        retirementPriceArr.filter(elem => elem.monthNbr === monthNbr);
    return currentPriceArr;
}
export default getCurrentPriceArr;